
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news-and-information/[id]",
      function () {
        return require("private-next-pages/news-and-information/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news-and-information/[id]"])
      });
    }
  